<template>
  <div class="wrapper_mhers herms_comwidth">
    <common-nav :options="options"></common-nav>
      <div id="mainSwiper">
        <home-swiper :options="options" :swiperList="swiperList"></home-swiper>
        <left-swiper :options="options" :swiperList="leftSwiperList"></left-swiper>
        <right-swiper :options="options" :swiperList="rightSwiperList"></right-swiper>
      </div>
      <home-game :homeGamesList="homeGamesList" :options="options"></home-game>
      <home-partners></home-partners>
      <common-footer :options="options"></common-footer>
      <loading :options="options"></loading>
      <nav-mask :options="options"></nav-mask>
      <common-mask :options="options"></common-mask>
      <screentips-mask></screentips-mask>
      <download-dialog :options="options" @closeDownloadDialog="closeDownloadDialog"></download-dialog>
       <slider-bar></slider-bar>
    </div>
</template>

<script>
import CommonFooter from "../components/common/CommonFooter.vue";
import CommonMask from "../components/common/CommonMask.vue";
import CommonNav from "../components/common/CommonNav.vue";
import Loading from "../components/common/Loading.vue";
import NavMask from "../components/common/NavMask.vue";
import ScreentipsMask from "../components/common/ScreenTips.vue";
import DownloadDialog from "../components/home/DownloadDialog.vue";
import HomeGame from "../components/home/HomeGame.vue";
import HomePartners from "../components/home/HomePartners";
import HomeSwiper from "../components/home/HomeSwiper.vue";
import LeftSwiper from "../components/home/LeftSwiper.vue";
import RightSwiper from "../components/home/RightSwiper.vue";
import SliderBar from "../components/sliderBar/index.vue";
export default {
  name: "App",
  provide() {
    return {
      reload: this.reload,
    };
  },
  components: {
    SliderBar,
    Loading,
    CommonNav,
    CommonFooter,
    HomeSwiper,
    LeftSwiper,
    RightSwiper,
    HomeGame,
    HomePartners,
    NavMask,
    ScreentipsMask,
    DownloadDialog,
    CommonMask,
  },
  data: function () {
    return {
      platFormType: "",
      gamesList: [],
      homeGamesList: [],
      leftSwiperList:[],
      rightSwiperList:[],
      swiperList: [],
      isFbDialog: false,
      options: {
        isLogin: false,
        isSign: false,
        isMask: false,
        isLoading: false,
        isIntegralNotes: false,
        isFootani: false,
        isLoginin: false,
        isLoginSuccess: false,
        isGameani: true,
        isnswiper: false,
        isnlist: false,
        isHmsLogin: true,
        isNavMask: false,
        isDownloadDialog: false,
        showLoginModal:false
      },
      scrollTimer: null
    };
  },
  created() {
    if (localStorage.getItem("token") && localStorage.getItem("userInfo")) {
      this.$store.commit("setToken", localStorage.getItem("token"));
      this.$store.commit("setUserInfo", JSON.parse(localStorage.getItem("userInfo")));
    }
  },
  computed: {
    isShowHomeLatestGame() {
      return this.$store.state.isShowHomeLatestGame;
    },
  },
  watch: {
    '$route': function(to, from) {
      // 当路由变化到首页时，且不是通过游戏列表跳转的，重置状态
      if ((to.path === '/' || to.path === '/home') && !this.isShowHomeLatestGame) {
        this.$store.commit('setIsShowHomeLatestGame', false);
      }
    }
  },
  mounted() {
    // 只有不是通过游戏列表跳转到首页时，才重置状态
    if (!this.isShowHomeLatestGame) {
      this.$store.commit('setIsShowHomeLatestGame', false);
    }

    // 判断用户是否登录
    if (localStorage.getItem("token")) {
      this.options.isLoginin = true;
    } else {
      this.thirdLogin();
    }
    this.getSwiperList();
    this.getLeftSwiperList()
    this.getRightSwiperList()
    this.getHomeGamesList();

    // 只有当 footer 点击设置了 navigateToHomeLatestGame 标志时才自动滚动到锚点
    try {
      const navFlag = sessionStorage.getItem('navigateToHomeLatestGame');
      if (navFlag === '1') {
  // 保证显式导航期间 store 保持高亮
  if (!this.$store.state.isShowHomeLatestGame) this.$store.commit('setIsShowHomeLatestGame', true);
        // 设置组件级锁，阻止自动滚动检测覆盖 footer 明确的高亮
        this.__footerNavLock = true;

        // 等待锚点与 header 渲染完成后精确滚动
        const waitForElement = (id, maxTries = 30, interval = 200) => {
          return new Promise((resolve) => {
            let tries = 0;
            const tick = () => {
              const el = document.getElementById(id);
              if (el) return resolve(el);
              tries++;
              if (tries >= maxTries) return resolve(null);
              setTimeout(tick, interval);
            };
            tick();
          });
        };

        this.$nextTick(() => {
          waitForElement('HomeLatestGame', 40, 150).then((element) => {
            if (!element) {
              // 没有找到锚点，释放锁
              setTimeout(() => { this.__footerNavLock = false; try { window.__mbFooterNavLock = false; } catch (e) {} }, 600);
              return;
            }

            // 计算 header 在视口中的底部位置（更鲁棒，处理 header 非 0 顶部的情况）
            const headerEl = document.querySelector('.header_m') || document.querySelector('.header') || document.querySelector('header');
            const headerRect = headerEl ? headerEl.getBoundingClientRect() : { bottom: (1.16 * parseFloat(getComputedStyle(document.documentElement).fontSize)) };

            const rect = element.getBoundingClientRect();
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            // 计算 viewport 内的差值：元素顶部到 header 底部的距离
            const delta = rect.top - headerRect.bottom;
            const targetPosition = Math.round(scrollTop + delta);

            // 初次平滑滚动
            window.scrollTo({ top: targetPosition, behavior: 'smooth' });

            // 校正循环：考虑图片懒加载或资源加载引起的位移（最多 6 次）
            let tries = 0;
            const correct = () => {
              tries++;
              const r2 = element.getBoundingClientRect();
              const newDelta = Math.round(r2.top - headerRect.bottom);
              if (Math.abs(newDelta) <= 1 || tries > 6) {
                // 完成后清理锁与 sessionStorage 标志
                setTimeout(() => {
                  this.__footerNavLock = false;
                  try { sessionStorage.removeItem('navigateToHomeLatestGame'); } catch (e) {}
                  try { window.__mbFooterNavLock = false; } catch (e) {}
                }, 80);
                return;
              }
              const currentScroll = window.pageYOffset || document.documentElement.scrollTop;
              const newTarget = Math.round(currentScroll + newDelta);
              window.scrollTo({ top: newTarget, behavior: 'auto' });
              setTimeout(correct, 120);
            };
            setTimeout(correct, 220);
          });
        });
      }
    } catch (e) {
      // ignore sessionStorage errors
      this.__footerNavLock = false;
    }

    // 添加滚动监听，检测用户是否在游戏列表区域
    this.addScrollListener();

    // 增加 IntersectionObserver 以更可靠地检测 #HomeLatestGame 是否在 header 下方可见
    try {
      const setupObserver = () => {
        const el = document.getElementById('HomeLatestGame');
        if (!el) return setTimeout(setupObserver, 200);

        const headerEl = document.querySelector('.header_m') || document.querySelector('.header') || document.querySelector('header');
        const headerH = headerEl ? Math.round(headerEl.getBoundingClientRect().height) : Math.round(1.16 * parseFloat(getComputedStyle(document.documentElement).fontSize));

        // rootMargin 将顶部上移 header 高度，从而把 "在 header 下方" 的区域作为可见判定
        const obs = new IntersectionObserver((entries) => {
          try {
            if (window && window.__mbFooterNavLock) return; // 若全局锁存在，尊重显式导航
          } catch (e) {}
          entries.forEach((entry) => {
            try {
              if (entry.isIntersecting && entry.intersectionRatio > 0.01) {
                if (!this.$store.state.isShowHomeLatestGame) this.$store.commit('setIsShowHomeLatestGame', true);
              } else {
                if (this.$store.state.isShowHomeLatestGame) this.$store.commit('setIsShowHomeLatestGame', false);
              }
            } catch (e) {}
          });
        }, { root: null, rootMargin: `-${headerH}px 0px 0px 0px`, threshold: [0.01] });

        obs.observe(el);
        this.__homeLatestObserver = obs;
      };
      setupObserver();
    } catch (e) {}
  },
  beforeDestroy() {
    // 移除滚动监听器
    this.removeScrollListener();
    if (this.__homeLatestObserver) {
      try { this.__homeLatestObserver.disconnect(); } catch (e) {}
      this.__homeLatestObserver = null;
    }
  },
  methods: {
    addScrollListener() {
      // 添加滚动监听器
      window.addEventListener('scroll', this.handleScroll, { passive: true });
    },
    removeScrollListener() {
      // 移除滚动监听器
      window.removeEventListener('scroll', this.handleScroll);
    },
    handleScroll() {
      // 节流函数，避免频繁触发
      if (this.scrollTimer) {
        clearTimeout(this.scrollTimer);
      }
      this.scrollTimer = setTimeout(() => {
        this.checkScrollPosition();
      }, 100);
    },
    checkScrollPosition() {
  // 如果全局锁存在（由 footer 或 banner 触发），短路自动检测以保留游戏列表高亮
  try { if (window && window.__mbFooterNavLock) return; } catch (e) {}

  // 优先判断：靠近顶部（header 区域）或 #mainSwiper 可见 -> 首页高亮（store false）
      try {
        // 优先检测：如果 #HomeLatestGame 在视口（尤其是位于 header 底部下方）则显示游戏列表高亮
        try {
          const gameEl = document.getElementById('HomeLatestGame');
          if (gameEl) {
            const gRect = gameEl.getBoundingClientRect();
            const headerEl = document.querySelector('.header_m') || document.querySelector('.header') || document.querySelector('header');
            const headerBottom = headerEl ? headerEl.getBoundingClientRect().bottom : 0;
            const winH = window.innerHeight || document.documentElement.clientHeight;

            // 可见区计算（考虑 header 覆盖）
            const visibleTop = Math.max(gRect.top, headerBottom);
            const visibleBottom = Math.min(gRect.bottom, winH);
            const visibleH = Math.max(0, visibleBottom - visibleTop);
            const ratio = visibleH / (gRect.height || 1);

            // 当锚点刚好紧贴 header 底部（用户滑动到该位置）也视为进入游戏列表区域
            const atHeader = (gRect.top <= headerBottom + 6 && gRect.bottom > headerBottom);

            if (atHeader || ratio > 0.02) {
              if (!this.isShowHomeLatestGame) this.$store.commit('setIsShowHomeLatestGame', true);
              return;
            }
          }
        } catch (e) {}
        const headerEl = document.querySelector('.header_m') || document.querySelector('.header') || document.querySelector('header');
        const headerHeight = headerEl ? headerEl.getBoundingClientRect().height : (1.16 * parseFloat(getComputedStyle(document.documentElement).fontSize));
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        // header 区域：若滚动位置在 headerHeight 以内，显示首页高亮
        if (scrollTop <= Math.max(0, Math.round(headerHeight))) {
          if (this.isShowHomeLatestGame) this.$store.commit('setIsShowHomeLatestGame', false);
          return;
        }

        // 检测 mainSwiper 可见性：若在视窗中有小量可见则视为首页区域
        const mainEl = document.getElementById('mainSwiper');
        if (mainEl) {
          const mRect = mainEl.getBoundingClientRect();
          const winH = window.innerHeight || document.documentElement.clientHeight;
          const visibleH = Math.min(mRect.bottom, winH) - Math.max(mRect.top, 0);
          const ratio = Math.max(0, visibleH) / (mRect.height || 1);
          if (ratio > 0.05) { // 可见比例阈值，保持较低以避免不灵敏
            if (this.isShowHomeLatestGame) this.$store.commit('setIsShowHomeLatestGame', false);
            return;
          }
        }

        // 其它情况：显示游戏列表高亮
        if (!this.isShowHomeLatestGame) this.$store.commit('setIsShowHomeLatestGame', true);
      } catch (e) {
        // ignore
      }
    },
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
    showLoginDialog: function () {
      this.options.isMask = true;
      this.options.isLogin = true;
    },
    closeDialog: function () {
      this.options.isLogin = false;
      this.options.isSign = false;
      this.options.isMask = false;
      this.options.isIntegralNotes = false;
      this.options.isNavMask = false;
      this.isFbDialog = false;
      this.options.showLoginModal = false
    },
    closeDownloadDialog: function () {
      this.options.isMask = false;
      this.options.isDownloadDialog = false;
    },
    handleLogin: function () {
      this.options.isLogin = false;
      this.options.isSign = true;
    },
    getSwiperList: function () {
      this.options.isLoading = true;
      this.getHttp(this, "", "/front/home/mobile/banner", function (obj, data) {
        if (data.status === 2000) {
          obj.swiperList = data.data;
        } else {
          obj.$toast(data.message);
        }
        obj.options.isLoading = false;
      });
    },
    // 大武道-首页中间左侧banner
    getLeftSwiperList: function () {
      const datas = {
        // game_id:'', //没有明确的game_id,直接不传值
        platform:2, //1-PC,2-MB
        position: 8,
      };
      this.getHttp(this, datas, "/front/home/position/banner", function (obj, data) {
        if (data.status === 2000) {
          obj.leftSwiperList = data.data;
        } else {
          obj.$toast(data.message);
        }
      });
    },
    // 大武道-首页中间右侧banner
    getRightSwiperList: function () {
      const datas = {
        // game_id:'',// game_id:'', 没有明确的game_id,直接不传值
        platform:2,
        position: 9,
      };
      this.getHttp(this,datas, "/front/home/position/banner", function (obj, data) {
        if (data.status === 2000) {
          obj.rightSwiperList = data.data;
        } else {
          obj.$toast(data.message);
        }
      });
    },
    getHomeGamesList: function () {
      this.getHttp(this, "", "/front/home/games", function (obj, data) {
        if (data.status === 2000) {
          obj.homeGamesList = data.data;
        } else {
          obj.$toast(data.message);
        }
      });
    },
    morefunLogin: function (userName, passWord) {
      this.options.isLoading = true;
      let datas = {
        account: userName,
        password: passWord,
      };
      this.postHttp(this, datas, "/front/login", function (obj, data) {
        if (data) {
          if (data.status === 2000) {
            obj.options.isLoading = false;
            // obj.$toast("登入成功!");
            obj.options.isLogin = false;
            obj.options.isLoginin = true;
            obj.options.isLoginSuccess = true;
            let token = data.data.bear_token;
            obj.$store.commit("setToken", token);
            obj.$store.commit("setUserInfo", userInfo);
            localStorage.setItem("token", token);
            localStorage.setItem("userInfo", JSON.stringify(userInfo));

            obj.reload();
            obj.options.isLoading = true;
            obj.options.isMask = true;
            obj.options.isSign = true;
            obj.options.isLoading = false;
          } else {
            obj.options.isLoading = false;
            obj.options.isLogin = false;
            obj.options.isSign = false;
            obj.options.isMask = false;
            obj.$toast(data.message);
          }
        } else {
          obj.options.isLoading = false;
          obj.options.isSign = false;
          obj.options.isMask = false;
          obj.options.isLogin = false;
          obj.$toast("網絡錯誤，請稍候重試!");
        }
      });
    },
    thirdLogin: function () {
      // 三方登录接口
      this.options.isLoading = true;
      this.account = this.$utils.getUrlKey("account");
      this.name = this.$utils.getUrlKey("name");
      this.token = this.$utils.getUrlKey("token");
      this.type = this.$utils.getUrlKey("type");
      this.signature = this.$utils.getUrlKey("signature");
      if (this.account && this.name && this.token && this.type) {
        let datas = {
          account: this.account,
          name: this.name,
          token: this.token,
          type: this.type, //facebook/google
        };
        this.postHttp(this, datas, "/front/others/login", function (obj, data) {
          if (data.status === 2000) {
            obj.options.isHmsLogin = false;
            obj.options.isLoading = false;
            obj.options.isMask = false;
            // obj.$toast("登入成功!");
            let token = data.data.bear_token;
            let userInfo = data.data.user_info;
            obj.$store.commit("setToken", token);
            obj.$store.commit("setUserInfo", userInfo);
            localStorage.setItem("token", token);
            localStorage.setItem("userInfo", JSON.stringify(userInfo));
            obj.$store.commit("setIsHmsLogin", false);
            // obj.reload();
            obj.$router.replace("/home");
          } else {
            obj.$toast(data.message);
            obj.options.isLoading = false;
          }
        });
      } else {
        this.options.isLoading = false;
      }
    },
  },
};
</script>

<style lang="stylus">
.wrapper_mhers {
  position relative
  max-width: 750px;
  min-width: 320px;
  margin: 0 auto;
}
</style>
